import Link from "next/link";
import UserImage from "../shared/user_image";
import useTranslation from "next-translate/useTranslation";
import Avatar from "react-avatar";
import { Fragment } from "react";

const MAX_USERS = 8;

const AvatarList = (props) => {
  const { t } = useTranslation("common");
  const maxUsers = props.maxUsers || MAX_USERS;

  const moreText = () => `+${props.totalCount - maxUsers}`.split("").join(" ");

  return (
    <>
      <div className="d-flex avatar-list">
        {props.users.slice(0, maxUsers).map((user) => (
          <Fragment key={user.id}>
            {props.membersListLink || props.profilesLink ? (
              <Link href={props.membersListLink ? props.membersListLink : `/profile/${user.id}`}>
                <a className="avatar-list_item">
                  <UserImage name={user.first_name} src={user.avatar_thumb} width={48} height={48} />
                </a>
              </Link>
            ) : (
              <a className="avatar-list_item">
                <UserImage name={user.first_name} src={user.avatar_thumb} width={48} height={48} />
              </a>
            )}
          </Fragment>
        ))}

        {props.showMoreLink && props.totalCount && props.totalCount > maxUsers && (
          <Link href={props.membersListLink || ""}>
            <a className="avatar-list_item">
              <div className="avatar-container d-flex justify-content-center text-center rounded-circle p-0">
                <div className="avatar d-flex aling-items-center justify-center rounded-circle object-fit-cover">
                  <Avatar
                    name={moreText()}
                    size={48}
                    round={true}
                    textSizeRatio={4}
                    color="#E9F6F9"
                    fgColor="#161616"
                  />
                </div>
              </div>
            </a>
          </Link>
        )}
      </div>

      {/* <div className="mt-1 label-2 overflow-hidden mt-2">
        {props.users
          .slice(0, 4)
          .map((user) => user.first_name)
          .join(", ")}{" "}
        {props.showOthers && t("groups.others")}
      </div> */}
    </>
  );
};

export default AvatarList;

AvatarList.defaultProps = {
  profilesLink: true,
};
